import React from 'react'
import logo from "../../images/logo.png"

const Header = ({ resources }) => {
    return (
        <>
            <div className="container mt-4 mb-4 page-container">
                <div className="page-container-smaller header-container" style={{ position: 'relative' }}>
                    <img src={logo} alt="AOZ Logo" className="img-fluid header-logo" style={{ maxHeight: '60px', position: 'absolute', left: '-220px', top: '50%', transform: 'translateY(-50%)' }} />
                    <span className="mb-0 title" style={{ color: '#e41a21', fontWeight: 'bold' }}>{resources?.HomeTitle}</span>
                </div>
            </div>
        </>
    )
}

export default Header